import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function FaqList() {
  const [active, setActive] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-50">
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-4">
          <span className="font-label text-xs tracking-[0.2em] text-primary-600">FAQ / 常见疑问</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            入口与下载常见疑问
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            围绕官网入口、APP 下载、最新地址与在线看，整理出最常被问到的几个问题。点击条目即可展开查看说明。
          </p>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-background-200 border-y border-background-200">
            {faqs.map((item, index) => {
              const isOpen = active === index;
              return (
                <div key={item.q}>
                  <button
                    type="button"
                    onClick={() => setActive(isOpen ? null : index)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 py-5 text-left"
                  >
                    <span className="flex items-start gap-3">
                      <span className="font-label text-xs font-medium text-primary-600">Q{index + 1}</span>
                      <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                        {item.q}
                      </span>
                    </span>
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-600">
                      <i className={isOpen ? 'ri-subtract-line text-base' : 'ri-add-line text-base'} />
                    </span>
                  </button>
                  {isOpen && (
                    <p className="animate-fade-in pb-5 pl-8 pr-10 text-sm leading-7 text-foreground-600">{item.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}